import Loading from '@/components/Loading/Loading';
import CollectionItemWrapper from './CollectionItemWrapper';
import { ProductsListProps } from './types';

const ProductsList = (props: ProductsListProps) => {
  const { isLoading, data } = props;
  const filteredResults = data.collections.filter(
    (collection): collection is typeof collection & { psku: string } =>
      !!collection.psku && !!data.products[collection.psku],
  );

  if (isLoading) {
    return (
      <div className="mt-20 flex justify-center">
        <Loading />
      </div>
    );
  }

  if (filteredResults.length === 0) {
    return (
      <div className="mt-8 text-center text-gray-700 lg:mt-20">
        Sorry, no products matched your selection.
      </div>
    );
  }

  return (
    <div className="mt-2.5 grid grid-cols-2 xs:grid-cols-3 sm:grid-cols-4 lg:grid-cols-3 xl:!grid-cols-4">
      {filteredResults.map((collection) => (
        <CollectionItemWrapper
          key={collection.key}
          offer={collection}
          product={data.products[collection.psku]}
        />
      ))}
    </div>
  );
};

export default ProductsList;
